/* Norvu theme · v0.1.0
   Tiny interactivity layer for the global shell.
   Iterations 2–4 will add per-template island bundles.
*/
(function () {
  'use strict';

  // ---------- Announcement bar rotator ----------
  function initAnnouncement() {
    var bar = document.querySelector('[data-rotate-ms]');
    if (!bar) return;
    var items = bar.querySelectorAll('.norvu-announcement__item');
    if (items.length < 2) return;
    var ms = parseInt(bar.getAttribute('data-rotate-ms'), 10) || 4000;
    var idx = 0;
    var paused = false;

    function show(i) {
      items.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
    }
    function next() { if (!paused) { idx = (idx + 1) % items.length; show(idx); } }

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        idx = (idx + dir + items.length) % items.length;
        show(idx);
      });
    });
    setInterval(next, ms);
  }

  // ---------- Mobile menu ----------
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    // Always-visible (no [hidden]) — use class toggle so CSS animates open/close
    menu.removeAttribute('hidden');
    toggle.addEventListener('click', function () {
      var open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnnouncement(); initMobileMenu();
    });
  } else {
    initAnnouncement(); initMobileMenu();
  }
})();
